// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'
import store from './store'
import Vuex from 'vuex'
import {
  scrollTo
} from '../src/functions/common'
import {
  post,
  get,
  requests,
  asyncJquery
} from '@/functions/ajax'
import {
  delay
} from './fun'
import lvDirectory from './components/lv-directory'
import infiniteScroll from 'vue-infinite-scroll'
import Loading from './components/loading'
import 'material-design-icons/iconfont/material-icons.css'
import 'animate.css'
import './sass/index.scss'
import { BASE_URL } from './libs/config'

Vue.prototype.$filePath = (fileId) => {
  return `${BASE_URL}/file/download/${fileId}`
}

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-cn'
import { formatTime } from './datas/tool'

function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return (false)
}

router.beforeEach(async(to, from, next) => {
  if (to.path === '/register') {
    next()
    return
  }
  if (getQueryVariable('license_key')) {
    localStorage.code = getQueryVariable('license_key')
  }
  const get_code = localStorage.code || false
  if (get_code) {
    if (!store.state.app.appInfo.appId) {
      await store.dispatch('app/getAppInfoBySite')
    }
    next()
  } else {
    next({
      path: '/register'
    })
  }
})

Vue.config.productionTip = false
Vue.use(Loading)
Vue.use(Vuex)
Vue.use(Router)
Vue.use(lvDirectory)
Vue.use(DatePicker)
Vue.use(infiniteScroll)
// Vue.prototype.$loading = Loading
Vue.prototype.$scrollTo = scrollTo
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$request = requests
Vue.prototype.$delay = delay
Vue.prototype.$formatTime = (time) => {
  return formatTime(time)
}

/* eslint-disable no-new */
new Vue({
  data () {
    return {
      config: '',
      point: '',
      area: ''
    }
  },
  async created () {
    const get_code = localStorage.code || false
    // const { result } = await get('https://hnxcja.12348.laway.cn/pufa/machine/current/version/')
    // if (!window.localStorage.version) {
    //   window.localStorage.version = result.version
    // }
    // if (parseInt(result.version) > parseInt(window.localStorage.version)) {
    //   if (NativeInterface && NativeInterface.clearAllCache) {// eslint-disable-line
    //     NativeInterface.clearAllCache() // eslint-disable-line
    //   }
    // }
    if (get_code) {
      let _this = this
      // 同步获取服务点信息
      let getInfo = function () {
        return new Promise(function (resolve, reject) {
          let success = ({
            info,
            status,
            msg
          }) => {
            if (!status) {
              console.log('err:' + msg)
              return
            }
            resolve(info)
          }
          asyncJquery(
            'https://hnxcja.12348.laway.cn/pufa/machine/',
            'POST', {
            no: get_code
          },
            success
          )
        })
      }
      // 同步获取站点信息并设置config
      var setData = function (info) {
        let success = ({
          msg,
          result,
          status
        }) => {
          if (!status) {
            console.log(msg)
            return
          }
          _this.point = info
          _this.config = result.info
          _this.area = result.area
        }
        asyncJquery(
          'https://hnxcja.12348.laway.cn/get/website/info/',
          'GET', {
          code: info.code
        },
          success
        )
      }

      getInfo().then(info => {
        setData(info)
      })
    }
  },
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js